import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-header border-0 pt-6 pb-2 er-header" }
const _hoisted_4 = { class: "er-bar" }
const _hoisted_5 = { class: "card-title m-0 me-2" }
const _hoisted_6 = { class: "m-0" }
const _hoisted_7 = { class: "er-chip" }
const _hoisted_8 = { class: "fw-bold" }
const _hoisted_9 = { class: "er-num fs-8 text-gray-600" }
const _hoisted_10 = {
  key: 0,
  class: "d-flex align-items-center gap-2"
}
const _hoisted_11 = { class: "fs-8 text-gray-600 mb-0" }
const _hoisted_12 = ["max", "disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1" }, null, -1)
const _hoisted_15 = {
  class: "er-quarters",
  role: "group"
}
const _hoisted_16 = ["aria-pressed"]
const _hoisted_17 = ["aria-pressed"]
const _hoisted_18 = { class: "er-chip" }
const _hoisted_19 = { class: "fs-8 text-gray-600" }
const _hoisted_20 = { class: "er-meter er-meter--wide er-meter--final" }
const _hoisted_21 = { class: "er-bar mt-4" }
const _hoisted_22 = ["aria-pressed", "onClick"]
const _hoisted_23 = { class: "er-num opacity-75 fw-bold ms-1" }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1" }, null, -1)
const _hoisted_26 = { class: "er-hint fs-8 text-gray-500" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("kbd", null, "J", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("kbd", null, "K", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("kbd", null, "A", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("kbd", null, "R", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("kbd", null, "Enter", -1)
const _hoisted_32 = { class: "table-responsive er-table" }
const _hoisted_33 = { class: "table align-middle fs-6 mb-0 er-tbl" }
const _hoisted_34 = { class: "text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("th", { class: "er-rail" }, null, -1)
const _hoisted_36 = { class: "min-w-150px" }
const _hoisted_37 = { class: "min-w-125px" }
const _hoisted_38 = { class: "min-w-75px" }
const _hoisted_39 = { class: "min-w-75px" }
const _hoisted_40 = { class: "min-w-75px" }
const _hoisted_41 = { class: "min-w-150px" }
const _hoisted_42 = { class: "min-w-175px text-end" }
const _hoisted_43 = { class: "fw-bold text-gray-600" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "d-block text-gray-800 fw-bolder" }
const _hoisted_46 = { class: "d-block fs-8 text-gray-500 fw-bold" }
const _hoisted_47 = { class: "er-num fw-bold text-gray-800" }
const _hoisted_48 = { class: "er-num" }
const _hoisted_49 = ["title"]
const _hoisted_50 = { class: "text-end" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_53 = {
  key: 1,
  class: "d-inline-flex align-items-center"
}
const _hoisted_54 = { key: 0 }
const _hoisted_55 = {
  colspan: "8",
  class: "text-center text-gray-500 py-10"
}
const _hoisted_56 = { class: "er-cards" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = { class: "er-card__body" }
const _hoisted_59 = { class: "flex-grow-1 pe-3 py-3" }
const _hoisted_60 = { class: "d-flex justify-content-between gap-3" }
const _hoisted_61 = { class: "d-block text-gray-800 fw-bolder" }
const _hoisted_62 = { class: "d-block fs-8 text-gray-500 fw-bold" }
const _hoisted_63 = { class: "text-end" }
const _hoisted_64 = { class: "er-num d-block fw-bold text-gray-800" }
const _hoisted_65 = { class: "er-card__meta fs-8 text-gray-500" }
const _hoisted_66 = { class: "text-primary fw-bolder" }
const _hoisted_67 = { class: "er-card__acts" }
const _hoisted_68 = ["onClick"]
const _hoisted_69 = {
  key: 1,
  class: "text-gray-500"
}
const _hoisted_70 = {
  key: 1,
  class: "d-inline-flex align-items-center"
}
const _hoisted_71 = {
  key: 0,
  class: "text-center text-gray-500 py-10"
}
const _hoisted_72 = {
  key: 0,
  class: "d-flex justify-content-end pt-6"
}
const _hoisted_73 = {
  key: 1,
  class: "overlay-layer card-rounded bg-dark bg-opacity-0"
}
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_75 = [
  _hoisted_74
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_ExpertReviewDrawer = _resolveComponent("ExpertReviewDrawer")!

  return (_ctx.can('read', 'indices'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.translate('expertReviewConsole')), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", {
                  class: _normalizeClass(["er-dot", { 'er-dot--final': _ctx.isFinal }])
                }, null, 2),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.quarterLabel), 1),
                _createElementVNode("span", {
                  class: _normalizeClass(["er-meter", { 'er-meter--final': _ctx.isFinal }])
                }, [
                  _createElementVNode("i", {
                    style: _normalizeStyle({ width: _ctx.elapsed + '%' })
                  }, null, 4)
                ], 2),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.elapsed) + "%", 1)
              ]),
              (_ctx.can('update', 'indices'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.translate('expertReviewEscalationAfter')), 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.escalationHours) = $event)),
                      type: "number",
                      min: "1",
                      max: _ctx.maxEscalationHours,
                      class: "form-control form-control-sm",
                      style: {"width":"84px"},
                      dir: "ltr",
                      disabled: _ctx.savingEscalation
                    }, null, 8, _hoisted_12), [
                      [
                        _vModelText,
                        _ctx.escalationHours,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-light-primary fw-bolder",
                      disabled: _ctx.savingEscalation || !_ctx.escalationHours,
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveEscalationHours && _ctx.saveEscalationHours(...args)))
                    }, _toDisplayString(_ctx.translate('save')), 9, _hoisted_13)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-sm er-filter", _ctx.quarterStatus === 'LIVE' ? 'btn-dark' : 'btn-light']),
                  "aria-pressed": _ctx.quarterStatus === 'LIVE',
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setQuarterStatus('LIVE')))
                }, _toDisplayString(_ctx.translate('expertReviewQuarterRunning')), 11, _hoisted_16),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["btn btn-sm er-filter", _ctx.quarterStatus === 'CLOSED' ? 'btn-dark' : 'btn-light']),
                  "aria-pressed": _ctx.quarterStatus === 'CLOSED',
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setQuarterStatus('CLOSED')))
                }, _toDisplayString(_ctx.translate('expertReviewQuarterEnded')), 11, _hoisted_17)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.translate('expertReviewProgress', {
                  done: _ctx.reviewedCount,
                  total: _ctx.counts.all,
                })), 1),
                _createElementVNode("span", _hoisted_20, [
                  _createElementVNode("i", {
                    style: _normalizeStyle({ width: _ctx.reviewedPercentage + '%' })
                  }, null, 4)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (item) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: item.key,
                  type: "button",
                  class: _normalizeClass(["btn btn-sm er-filter", _ctx.filter === item.key ? 'btn-dark' : 'btn-light']),
                  "aria-pressed": _ctx.filter === item.key,
                  onClick: ($event: any) => (_ctx.setFilter(item.key))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.translate(item.label)) + " ", 1),
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.counts[item.count]), 1)
                ], 10, _hoisted_22))
              }), 128)),
              (_ctx.can('update', 'indices'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-sm btn-light-success fw-bolder",
                    disabled: _ctx.loading,
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.approveLowRisk && _ctx.approveLowRisk(...args)))
                  }, _toDisplayString(_ctx.translate('expertReviewApproveLowRisk')), 9, _hoisted_24))
                : _createCommentVNode("", true),
              _hoisted_25,
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _hoisted_28,
                _createTextVNode(" " + _toDisplayString(_ctx.translate('expertReviewShortcutMove')) + " ", 1),
                (_ctx.can('update', 'indices'))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" · "),
                      _hoisted_29,
                      _createTextVNode(" " + _toDisplayString(_ctx.translate('expertReviewShortcutApprove')) + " · ", 1),
                      _hoisted_30,
                      _createTextVNode(" " + _toDisplayString(_ctx.translate('expertReviewShortcutReject')), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                _createTextVNode(" · "),
                _hoisted_31,
                _createTextVNode(" " + _toDisplayString(_ctx.translate('expertReviewShortcutEvidence')), 1)
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["card-body pt-4", { 'overlay overlay-block': _ctx.loading }])
          }, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("table", _hoisted_33, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("th", _hoisted_36, _toDisplayString(_ctx.translate('expertReviewColArea')), 1),
                    _createElementVNode("th", _hoisted_37, _toDisplayString(_ctx.translate('expertReviewColPrice')), 1),
                    _createElementVNode("th", _hoisted_38, _toDisplayString(_ctx.translate('expertReviewColQoq')), 1),
                    _createElementVNode("th", _hoisted_39, _toDisplayString(_ctx.translate('expertReviewColYoy')), 1),
                    _createElementVNode("th", _hoisted_40, _toDisplayString(_ctx.translate('expertReviewColDeals')), 1),
                    _createElementVNode("th", _hoisted_41, _toDisplayString(_ctx.translate('expertReviewColEvidence')), 1),
                    _createElementVNode("th", _hoisted_42, _toDisplayString(_ctx.translate('expertReviewColDecision')), 1)
                  ])
                ]),
                _createElementVNode("tbody", _hoisted_43, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: row.id,
                      class: _normalizeClass(["er-row", {
                  'er-row--cursor': index === _ctx.cursor,
                  'er-row--done': row.status !== 'PENDING',
                }]),
                      onClick: ($event: any) => (_ctx.openDrawer(row.id))
                    }, [
                      _createElementVNode("td", {
                        class: _normalizeClass(["er-rail", { 'is-high': row.risk === 'HIGH' }])
                      }, null, 2),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.isArabic ? row.titleAr : row.titleEn), 1),
                        _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.isArabic ? row.titleEn : row.titleAr), 1)
                      ]),
                      _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.fmt(_ctx.livePrice(row))), 1),
                      _createElementVNode("td", {
                        class: _normalizeClass(["er-num", _ctx.deltaClass(_ctx.liveQoq(row))])
                      }, _toDisplayString(_ctx.pct(_ctx.liveQoq(row))), 3),
                      _createElementVNode("td", {
                        class: _normalizeClass(["er-num", _ctx.deltaClass(row.yoyChange)])
                      }, _toDisplayString(_ctx.pct(row.yoyChange)), 3),
                      _createElementVNode("td", _hoisted_48, _toDisplayString(row.dealsCount), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", 
                      row.isThinCluster
                        ? 'badge-light-danger'
                        : _ctx.BADGES[row.evidence]
                    ]),
                          title: 
                      row.isThinCluster
                        ? _ctx.translate('expertReviewThinTitle')
                        : ''
                    
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.translate('expertReviewEvidence' + row.evidence)), 1),
                          (row.isThinCluster)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" · " + _toDisplayString(_ctx.translate('expertReviewThin', {
                          count: row.clusterDealsCount,
                        })), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_49)
                      ]),
                      _createElementVNode("td", _hoisted_50, [
                        (row.status === 'PENDING')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.can('update', 'indices'))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "btn btn-sm btn-success me-2",
                                    onClick: _withModifiers(($event: any) => (_ctx.approve(row)), ["stop"])
                                  }, _toDisplayString(_ctx.translate('expertReviewApprove')), 9, _hoisted_51))
                                : (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(_ctx.translate('expertReviewPendingDecision')), 1))
                            ], 64))
                          : (_openBlock(), _createElementBlock("span", _hoisted_53, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["er-seal", { 'er-seal--no': row.status === 'REJECTED' }])
                              }, _toDisplayString(_ctx.decisionSeal(row)), 3),
                              _createElementVNode("span", {
                                class: _normalizeClass(["ms-2 fw-bolder", _ctx.decisionClass(row)])
                              }, _toDisplayString(_ctx.decisionLabel(row)), 3)
                            ]))
                      ])
                    ], 10, _hoisted_44))
                  }), 128)),
                  (!_ctx.rows.length)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_54, [
                        _createElementVNode("td", _hoisted_55, _toDisplayString(_ctx.translate('expertReviewEmptyFilter')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_56, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: row.id,
                  class: "er-card",
                  onClick: ($event: any) => (_ctx.openDrawer(row.id))
                }, [
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["er-rail", { 'is-high': row.risk === 'HIGH' }])
                    }, null, 2),
                    _createElementVNode("div", _hoisted_59, [
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.isArabic ? row.titleAr : row.titleEn), 1),
                          _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.isArabic ? row.titleEn : row.titleAr), 1)
                        ]),
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.fmt(_ctx.livePrice(row))), 1),
                          _createElementVNode("span", {
                            class: _normalizeClass(["er-num d-block fs-8", _ctx.deltaClass(_ctx.liveQoq(row))])
                          }, _toDisplayString(_ctx.translate('expertReviewQoqShort', {
                          value: _ctx.pct(_ctx.liveQoq(row)),
                        })), 3)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", 
                      row.isThinCluster
                        ? 'badge-light-danger'
                        : _ctx.BADGES[row.evidence]
                    ])
                        }, _toDisplayString(_ctx.translate('expertReviewEvidence' + row.evidence)), 3),
                        _createElementVNode("span", null, _toDisplayString(_ctx.translate('expertReviewDealsShort', {
                        count: row.dealsCount,
                      })), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.translate('expertReviewYoyShort', {
                        value: _ctx.pct(row.yoyChange),
                      })), 1),
                        _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.translate('expertReviewTapForEvidence')), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    (row.status === 'PENDING')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.can('update', 'indices'))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "btn btn-sm btn-success flex-grow-1",
                                onClick: _withModifiers(($event: any) => (_ctx.approve(row)), ["stop"])
                              }, _toDisplayString(_ctx.translate('expertReviewApprove')), 9, _hoisted_68))
                            : (_openBlock(), _createElementBlock("span", _hoisted_69, _toDisplayString(_ctx.translate('expertReviewPendingDecision')), 1))
                        ], 64))
                      : (_openBlock(), _createElementBlock("span", _hoisted_70, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["er-seal", { 'er-seal--no': row.status === 'REJECTED' }])
                          }, _toDisplayString(_ctx.decisionSeal(row)), 3),
                          _createElementVNode("span", {
                            class: _normalizeClass(["ms-2 fw-bolder", _ctx.decisionClass(row)])
                          }, _toDisplayString(_ctx.decisionLabel(row)), 3)
                        ]))
                  ])
                ], 8, _hoisted_57))
              }), 128)),
              (!_ctx.rows.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_71, _toDisplayString(_ctx.translate('expertReviewEmptyFilter')), 1))
                : _createCommentVNode("", true)
            ]),
            (_ctx.totalItems > _ctx.pageSize)
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                  _createVNode(_component_el_pagination, {
                    "current-page": _ctx.currentPage,
                    "page-size": _ctx.pageSize,
                    total: _ctx.totalItems,
                    layout: "prev, pager, next",
                    "hide-on-single-page": true,
                    background: "",
                    onCurrentChange: _ctx.pageChanged
                  }, null, 8, ["current-page", "page-size", "total", "onCurrentChange"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_73, _hoisted_75))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _createVNode(_component_ExpertReviewDrawer, {
          row: _ctx.selectedRow,
          "cluster-deals": _ctx.selectedClusterDeals,
          quarter: _ctx.quarter,
          "quarter-label": _ctx.quarterLabel,
          reasons: _ctx.rejectReasons,
          "details-status": _ctx.detailsStatus,
          "reasons-status": _ctx.reasonsStatus,
          open: _ctx.drawerOpen,
          "can-update": _ctx.can('update', 'indices'),
          onClose: _ctx.closeDrawer,
          onApprove: _ctx.approveFromDrawer,
          onReject: _ctx.rejectFromDrawer
        }, null, 8, ["row", "cluster-deals", "quarter", "quarter-label", "reasons", "details-status", "reasons-status", "open", "can-update", "onClose", "onApprove", "onReject"]),
        _createElementVNode("div", {
          class: _normalizeClass(["er-toast", { 'is-on': _ctx.toast.visible }])
        }, [
          _createElementVNode("b", null, _toDisplayString(_ctx.toast.subject), 1),
          _createTextVNode(" " + _toDisplayString(_ctx.toast.message), 1)
        ], 2)
      ]))
    : _createCommentVNode("", true)
}